<template>
    <div class = "print" v-if="getPermission.loads.view || getPermission.stc.view">

        <md-tabs md-sync-route class="load-and-bill-tabs">
          <!-- <md-tab id="tab-confirm_load" md-label="Load" to="/confirm/load"></md-tab> -->
          <!-- <md-tab id="tab-confirm_stage" md-label="Confirm Load/Stage" to="/confirm/stage"></md-tab> -->
          <md-tab id="tab-confirm_aparload" md-label="Load Billing" to="/confirm/aparload"></md-tab>
          <md-tab id="tab-confirm_aparstage" md-label="Stage Cost" to="/confirm/aparstage"></md-tab>
          <md-tab v-if="getPermission.stcClerk.view" id="tab-confirm_aparstagemass" md-label="Stage Cost(Mass)" to="/confirm/aparstagemass"></md-tab>
        </md-tabs>
        <router-view/>
    </div>

</template>

<style lang="scss">


  .load-and-bill-tabs {
    .md-tabs-navigation {
      .md-theme-default {
        height: 30px;
      }
    }
  }

  


</style>


<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({}),
    computed: {
      ...mapGetters([
        'getPermission',
        'getMasterDataName',
      ]),
    },
  };

</script>



